import { Json, Required, Schema, Size, TextField } from "lego-gui-lib/lib";
import { api, mainStore } from "../../core/mainStore";
import { t } from "../../core/i18n/i18n";
import { RemoteDataSource } from "lego-gui-lib";
import { PropertyFK } from "../property/schema";
import { RemoteChildDataSource } from "lego-gui-lib/lib/dataAccess/RemoteChildDataSource";
import {
  queryParamDtoStrategy,
  queryParamParentChangeStrategy
} from "lego-gui-lib/lib/dataAccess/ChildDataSourceStrategies";
import { Auth } from "../../core/model/auth";

export const PropertyValueSchema = new Schema({
  fields: [
    {
      name: "propertyName",
      type: TextField(Required),
      title: t("common:name"),
      readonly: true,
      renderSize: Size.NORMAL
    },
    {
      name: "propertyValue",
      title: t("common:value"),
      type: Json({
        parse: true,
        collapsed: 3,
        displayDataTypes: false,
        enableClipboard: false
      })
    }
  ],
  primaryKey: ["id"],
  security: {
    readableRole: Auth.Roles.PLATFORM_ADMIN,
    editableRole: Auth.Roles.PLATFORM_ADMIN
  }
});

// for nested indexView on Property showView
export const ForeignPropertyValueColumns = PropertyValueSchema.extend({
  propertyName: false
});

export const ShowPropertyValueColumns = PropertyValueSchema.extend({
  propertyName: { type: TextField(), readonly: true }
});

mainStore.propertyValue = RemoteDataSource.create({
  api: api,
  name: "propertyValue",
  schema: PropertyValueSchema,
  url: "/propertyValues",
  commons: mainStore.commons
});

mainStore.propertyValueNested = RemoteChildDataSource.clone(
  mainStore.propertyValue,
  {
    parent: mainStore.property.oneDataSource,
    parentChangedStrategy: queryParamParentChangeStrategy(
      "propertyName",
      "propertyName"
    ),
    dtoStrategy: queryParamDtoStrategy("propertyName", "propertyName")
  }
);
